import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Users } from 'lucide-react';
import { PromotionPageLayout } from '@/components/layout/PromotionPageLayout';
import { PromotionModalHeader } from '@/components/layout/PromotionModalHeader';
import { PromotionModalFooter } from '@/components/layout/PromotionModalFooter';
import { RoleSelector } from './components/RoleSelector';
import { ROUTES } from '@/constants/routes';

export default function PromotionEnrollment() {
  const navigate = useNavigate();
  const location = useLocation();
  const incoming = location.state ?? {};
  const [role, setRole] = useState(incoming.role ?? '');
  const [submissionId] = useState(() => incoming.submissionId ?? crypto.randomUUID());
  function handleSubmit(e) {
    e.preventDefault();
    if (!role) return;
    navigate(ROUTES.promotionProfile, {
      state: { ...incoming, role, submissionId },
    });
  }
  return (
    <PromotionPageLayout step={1} totalSteps={4} modal modalSize="md">
      <PromotionModalHeader
        icon={Users}
        title="Who's enrolling?"
        subtitle="Pick the option that fits."
      />
      <form onSubmit={handleSubmit}>
        <RoleSelector value={role} onChange={setRole} />
        <PromotionModalFooter disabled={!role}>Continue</PromotionModalFooter>
      </form>
    </PromotionPageLayout>
  );
}